module.exports = __webpack_public_path__ + "assets/img/step10-sz.812d2c52.png";